import { render } from "./GlobalChatDock.vue?vue&type=template&id=03fd8be0&scoped=true"
import script from "./GlobalChatDock.vue?vue&type=script&lang=js"
export * from "./GlobalChatDock.vue?vue&type=script&lang=js"

import "./GlobalChatDock.vue?vue&type=style&index=0&id=03fd8be0&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/CodeAC/onlinejudgeFE/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fd8be0"]])

export default __exports__